import { render, staticRenderFns } from "./ConfigurazioniMagazzinoArticoliMultiploListComponent.vue?vue&type=template&id=d1d90666"
import script from "./ConfigurazioniMagazzinoArticoliMultiploListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniMagazzinoArticoliMultiploListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports